import { Row } from '@tanstack/react-table';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { eventRuleBaseSchema } from '@/features/event-rules/schemas/event-rules.schema.ts';
import { DotsHorizontalIcon } from '@radix-ui/react-icons';
import { EventRulesTableRowActionEditDialog } from '@/features/event-rules/components/event-rules-table/event-rules-table-row-action-edit-dialog.tsx';
import EventRulesTableRowActionDeleteDialog from '@/features/event-rules/components/event-rules-table/event-rules-table-row-action-delete-dialog.tsx';

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function EventRulesTableRowActions<TData>({ row }: DataTableRowActionsProps<TData>) {
  const eventRule = eventRuleBaseSchema.parse(row.original);

  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="data-[state=open]:bg-muted flex h-8 w-8 p-0 hover:bg-gray-200"
          >
            <DotsHorizontalIcon className="h-5 w-5" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]">
          <DropdownMenuItem asChild>
            <EventRulesTableRowActionEditDialog eventRule={eventRule} />
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <EventRulesTableRowActionDeleteDialog eventRule={eventRule} />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
